"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadErrorMessage = void 0;
var React = require("react");
require("./UploadErrorMessage.css");
var UploadErrorMessage = (function (_super) {
    __extends(UploadErrorMessage, _super);
    function UploadErrorMessage(props) {
        return _super.call(this, props) || this;
    }
    UploadErrorMessage.prototype.render = function () {
        var errorMessage = this.props.errorMessage;
        return errorMessage ? React.createElement("p", { className: "p-file-upload-error p-t-error50" }, errorMessage) : null;
    };
    UploadErrorMessage.defaultProps = {
        errorMessage: ''
    };
    return UploadErrorMessage;
}(React.Component));
exports.UploadErrorMessage = UploadErrorMessage;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["UploadErrorMessage"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/UploadErrorMessage/UploadErrorMessage.js
// module id = 367
// module chunks = 0 2